/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'yes' }, { id: 'absolutely' }, { id: 'probably' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-women-would-try"
      progress={68}
      field="hairstyleWomenWouldTry"
      setter="setHairstyleWomenWouldTry"
      ns="hairstyleWomenWouldTry"
      imageName="hairstyleWomenWouldTry"
      options={OPTIONS}
    />
  );
}

export default Page;
